import React from "react";
import l from "components/util/l";
import Comments from "components/brief/reviewer/revision/content/annotations/RevisionAnnotationComments";
import EmptyPlaceholder from "components/brief/util/helpers/EmptyPlaceholder";
import Mockups from "components/brief/reviewer/revision/content/mockups/RevisionMockups";
import Sections from "components/brief/reviewer/revision/content/RevisionSections";
import AdditionalComments from "components/brief/reviewer/revision/content/comments/RevisionAdditionalComments";
import Cover from "components/brief/reviewer/revision/content/cover/RevisionCover";
import Instructions from "components/brief/reviewer/revision/content/cover/RevisionInstructions";
import RevisionIndex from "components/brief/reviewer/revision/content/index/RevisionIndex";

const RevisionContentView = ({
  flow,
  proposal,
  currentSection,
  indexSections,
  allowComments,
  isSaving,
  showReadOnlyEmptyState,
  setGlobalAdditionalComments,
  onClickEditProposal,
  onClickNextSection,
  onClickSelectSection,
  onClickSaveRevision,
}) => {

  const showAdditionalCommentsSection = currentSection.isExtra;
  const showRevisionContent = !showReadOnlyEmptyState && !currentSection.staticType && !showAdditionalCommentsSection;

  return (
    <div className="flex-fill overflow-hidden text-left">
      <div className="row h-100 m-0 justify-content-center overflow-auto">
        {showReadOnlyEmptyState && (
          <EmptyPlaceholder
            mainIconClass="fas fa-file-alt"
            title={l("Revisión%PA347")}
            description={l("No hay secciones en esta ficha%PA413")}
            actionLabel={onClickEditProposal ? l("Editar%GA002") : null}
            actionIcon={onClickEditProposal ? "fas fa-edit" : null}
            onClickAction={onClickEditProposal}
          />
        )}

        {!showReadOnlyEmptyState && currentSection.staticType === "preliminary" && (
          <Cover
            flow={flow}
            onClickNext={onClickNextSection}
          />
        )}

        {!showReadOnlyEmptyState && currentSection.staticType === "objective" && (
          <Instructions
            onClickNext={onClickNextSection}
          />
        )}

        {!showReadOnlyEmptyState && currentSection.staticType === "index" && (
          <RevisionIndex
            sections={indexSections}
            onClickSelectSection={onClickSelectSection}
          />
        )}

        {!showReadOnlyEmptyState && showAdditionalCommentsSection && (
          <AdditionalComments
            allowComments={allowComments}
            globalAdditionalComments={proposal.additional_comments || ""}
            onChangeGlobalAdditionalComments={setGlobalAdditionalComments}
            onClickSaveRevision={onClickSaveRevision}
            isSaving={isSaving}
          />
        )}

        {showRevisionContent && (
          <>
            <Mockups currentSection={currentSection} />
            <Sections currentSection={currentSection} />
            <Comments currentSection={currentSection} />
          </>
        )}
      </div>
    </div>
  );

}

export default RevisionContentView;
